import { Box } from '@material-ui/core';
import { Currency, EditableField } from '@nemuru-eng/js-api-client';
import { useFormContext, useWatch } from 'react-hook-form';

import { AutomobileForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/components/AutomobileForm';
import { AutomobileFormFieldName } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormFieldName';
import { AutomobileFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/types/AutomobileFormItem';
import { VehiclePreviousValuesMap } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/maps/vehiclePreviousValues.map';
import { EditAutoPaymentMethodFormFields } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/schemas/editAutoPaymentMethodForm.schema';
import { doesEditableFieldExistInArray } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/maps/editableFieldToFormField.map';

interface EditVehicleStepProps {
  currency: Currency;
  editableFields: EditableField[];
  isFieldDisabled: (fieldName: AutomobileFormFieldName) => boolean;
  initialFormItem: AutomobileFormItem;
}

export const EditVehicleStep = ({ currency, editableFields, isFieldDisabled, initialFormItem }: EditVehicleStepProps) => {
  const isVehicleAmountEditable = doesEditableFieldExistInArray(editableFields, EditableField.VEHICLE_AMOUNT);
  const { control } = useFormContext<EditAutoPaymentMethodFormFields>();

  const [identificationNumber, price, registrationDate] = useWatch({
    control,
    name: ['item.identificationNumber', 'item.price', 'item.registrationDate'],
  });

  const previousValues = VehiclePreviousValuesMap.toChangedFields(
    initialFormItem,
    { price, registrationDate },
    currency,
  );

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <AutomobileForm
        isFieldDisabled={isFieldDisabled}
        showLoadingUntilInitialized
        vehicleAmountEditProps={{
          isVehicleAmountEditable,
          currency,
        }}
        alwaysShowFieldsWhenNewVehicle
        highlightEditableFields
        previousValues={previousValues}
        shouldCheckIdentificationReference={
          !!identificationNumber && identificationNumber !== initialFormItem.identificationNumber
        }
        dense
      />
    </Box>
  );
};
